import { useQuery } from "@tanstack/react-query";
import { uploadsApi, s3KeyFromStored } from "../api/uploads";

// Resolves a private-bucket S3 key/URL to a presigned GET URL.
// Shared by S3Image, S3Avatar, and the zoom viewer so the fetch is deduped
// (react-query caches by queryKey — all three end up sharing one request).
export function useSignedImageUrl(src?: string | null) {
  const key = s3KeyFromStored(src);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["s3-image", key],
    queryFn: () => uploadsApi.presignedGet(key as string),
    enabled: !!key,
    staleTime: 50 * 60 * 1000, // refresh well before the 1h presign expiry
    retry: 1,
  });

  return { key, url: data, isLoading, isError };
}
